import type {
  TPendingPlaylistSwapFlushReason,
  TPendingPlaylistSwapPhase
} from '@/helpers/pendingPlaylistSwapFlushGate'

export type TPlaylistSwapDiagnosticsSample = {
  feedPlaylistIdentity: string | null
  materializedPlaylistIdentity: string | null
  pendingPlaylistSwapPhase: TPendingPlaylistSwapPhase | null
  pendingPlaylistSwapProgress01: number | null
  pendingPlaylistSwapTitle: string | null
  pendingPlaylistSwapFlushReason: TPendingPlaylistSwapFlushReason | null
  pendingPlaylistSwapArmedAtMs: number | null
  pendingPlaylistSwapReadyAtMs: number | null
  pendingPlaylistSwapFlushStartedAtMs: number | null
  pendingPlaylistSwapFlushEndedAtMs: number | null
  feedAheadOfMaterialization: boolean
}

type TProvider = () => TPlaylistSwapDiagnosticsSample | null

let provider: TProvider | null = null

export function registerPlaylistSwapDiagnosticsProvider(fn: TProvider): void {
  provider = fn
}

export function peekPlaylistSwapDiagnosticsSample(): TPlaylistSwapDiagnosticsSample | null {
  if (provider == null) {
    return null
  }
  try {
    return provider()
  }
  catch {
    return null
  }
}

export function clearPlaylistSwapDiagnosticsProviderForTests(): void {
  provider = null
}

/** True when the sample should force an always-on diagnostics snapshot (no session). */
export function isPlaylistSwapDiagnosticsInteresting(
  sample: TPlaylistSwapDiagnosticsSample | null | undefined
): boolean {
  if (sample == null) {
    return false
  }
  return (
    sample.feedAheadOfMaterialization
    || sample.pendingPlaylistSwapPhase != null
    || sample.pendingPlaylistSwapFlushReason != null
    || sample.pendingPlaylistSwapArmedAtMs != null
  )
}
